import React from "react";

import { Box } from "@mui/material";

import { useLocation } from "react-router-dom";

import useAuthStore from "../../Zustand/Store/useAuthStore";

import FaceAuth from "./FaceAuth";

import FaceAuth2 from "./FaceAuth2";

import { isManagerKioskPageState, resolveAttendancePageState } from "../../Utils/attendanceAuth";



export default function MainAuth() {

  const { isLoggedIn, mode, userData } = useAuthStore();

  const location = useLocation();



  if (!isLoggedIn) {

    return <></>;

  }



  const pageState = resolveAttendancePageState(userData, location.state);

  const isKiosk = isManagerKioskPageState(pageState, userData);



  if (isKiosk) {

    return (

      <Box

        sx={{

          width: "100%",

          height: "100vh",

          display: "flex",

          flexDirection: "column",

          overflow: "hidden",

          backgroundColor: "#f4f6f8",

        }}

      >

        <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>

          <FaceAuth key="face-kiosk-unified" />

        </Box>

      </Box>

    );

  }



  return mode === 1 ? (

    <FaceAuth key="face-employee" />

  ) : (

    <FaceAuth2 key="face-intern" />

  );

}


